import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DragAndDropLayoutIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DragAndDropLayout",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.19 10.56a2 2 0 0 0-.12-.35s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.53-7.5c-.08-.08-.18-.16-.29-.22s-.08 0-.08 0c-.1-.05-.21-.09-.33-.11S9 2.01 9 2.01c-2.31 0-4.18 1.86-4.21 4.16v20.1c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.84c0-.1-.01-.19-.03-.28Zm-7.92 1.68h5.1v6.66h-10.4V4.76h2.92V9.9c0 1.29 1.05 2.34 2.34 2.34zM7.58 26.26V6.16c0-.77.63-1.4 1.4-1.4h3.12v22.4H8.98c-.64.04-1.4-.13-1.4-.9m15.43.97h-9.04v-6.45h10.4v5.47c0 .77-.73.93-1.37.93v.04Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 31.86h-16a1.14 1.14 0 1 1 0-2.28h16a1.14 1.14 0 1 1 0 2.28M6.43 27.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V3.29C1.86 1.4 3.4-.14 5.29-.14h20.57c1.89 0 3.43 1.54 3.43 3.43v4.57a1.14 1.14 0 1 1-2.28 0V3.29c0-.63-.51-1.14-1.14-1.14H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h1.14a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 21.57c-.63 0-1.14-.51-1.14-1.14v-6.86c0-1.89 1.54-3.43 3.43-3.43s3.43 1.54 3.43 3.43v2.29a1.14 1.14 0 1 1-2.28 0v-2.29a1.14 1.14 0 1 0-2.28 0v6.86c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.15 20.43c-.63 0-1.14-.51-1.14-1.14v-3.43a1.14 1.14 0 1 0-2.28 0 1.14 1.14 0 1 1-2.28 0v-2.29a1.14 1.14 0 1 0-2.28 0v2.29a1.14 1.14 0 1 1-2.28 0v-2.29c0-1.89 1.54-3.43 3.43-3.43 1.58 0 2.91 1.07 3.31 2.53.39-.16.82-.24 1.26-.24 1.89 0 3.43 1.54 3.43 3.43v3.43c0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.57 27.29h-9.14c-3.15 0-5.71-2.56-5.71-5.71v-3.43c0-1.89 1.54-3.43 3.43-3.43h2.29c.63 0 1.14.51 1.14 1.14v3.43a1.14 1.14 0 1 1-2.28 0V17h-1.14c-.63 0-1.14.51-1.14 1.14v3.43c0 1.89 1.54 3.43 3.43 3.43h9.14c1.89 0 3.43-1.54 3.43-3.43V17a1.14 1.14 0 1 1 2.28 0v4.57c0 3.15-2.56 5.71-5.71 5.71Z"
      })]
    })
  }));
};
DragAndDropLayoutIcon.displayName = 'DragAndDropLayoutIcon';